import { apiClient } from '@/lib/api-client';

/** A media asset resolved to a preview-ready URL (presigned GET). */
export interface ResolvedMedia {
  id: string;
  url: string;
  fileName: string;
  kind?: string;
  mimeType?: string;
}

/** Resolve a single media id → preview URL (for showing an existing value). */
export const resolveMedia = async (id: string): Promise<ResolvedMedia> => {
  const { data } = await apiClient.get<ResolvedMedia>(`/admin/website/media/${id}`);
  return data;
};

/** Resolve several media ids at once (galleries / arrays). */
export const resolveMediaBatch = async (ids: string[]): Promise<ResolvedMedia[]> => {
  if (ids.length === 0) return [];
  const { data } = await apiClient.get<ResolvedMedia[]>('/admin/website/media/batch', {
    params: { ids: ids.join(',') },
  });
  return data;
};
